// extracted by mini-css-extract-plugin
export default {"secondImage":"secondImage_FigiG","focused":"focused_nt2U4","show":"show_SusyS","fade":"fade_aM4sC","fade-in-animation":"fade-in-animation_e6sdU"};